<template>
  <div>
    <br>
    <h3 v-translate>The content will be available soon.</h3>
  </div>
</template>

<script>
export default {
  name: "ComingSoon"
}
</script>